var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./SubmissionFormSaveDraft.jinja');
require('./SubmissionFormSaveDraft.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .SubmissionFormSaveDraft-okButton': 'onOkClick',
        'click': 'onBGClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        params = params || {};

        $('body').on('keydown', this.onKeyDown);

        this.cb = params.cb;
        this.$el.addClass('SubmissionFormSaveDraft--visible');

        if (params.contributors && params.contributors.length) {
            if (params.contributors.length > 1) {
                var emails = '<br>An e-mail has been also sent to:<br>' + params.contributors.join('<br>');
            } else {
                var emails = '<br>An e-mail has been also sent to ' + params.contributors[0];
            }
            this.$('.SubmissionFormSaveDraft-emails').html(emails);
        } else {
            this.$('.SubmissionFormSaveDraft-emails').empty();
        }
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        this.$el.removeClass('SubmissionFormSaveDraft--visible');
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.SubmissionFormSaveDraft-body').length) return;

        this.onOkClick();
    },

    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.onOkClick();
        }
    },


    onOkClick: function () {
        this.hide();

        this.cb && this.cb(true);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionFormSaveDraft/SubmissionFormSaveDraft.js
// module id = 129
// module chunks = 0